const e=async(e,t,n)=>(await e.delete(`/orgs/${t}/email-template/${n}`)).data;export{e as resetEmailTemplate};
//# sourceMappingURL=reset-email-template.mjs.map